import {DiscordSnowflake} from '@colonist/types'
import {Events} from '@discord/embedded-app-sdk'
import {ShareActivityLinkAnalytics} from './entity_datas/EntityDatas'

export type DiscordEvent = Events

export interface DiscordContentFrameMessageData {
    messageId?: string | undefined
    event?: string | undefined
    subscription?: DiscordEvent | undefined
    command?: DiscordCommand | undefined
    data?: Record<string, unknown> | undefined
    args?: Record<string, unknown> | undefined
}

export enum DiscordCommand {
    ContentFrameReady = 'content-frame-ready',
    Subscribe = 'subscribe',
    Unsubscribe = 'unsubscribe',
    SetActivity = 'set-activity',
    DispatchDiscordEvent = 'dispatch',
    OpenExternalLink = 'open-external-link',
    InviteFriends = 'invite-friends',
    Purchase = 'purchase',
    ShareMoment = 'share-moment',
    ShareActivityLink = 'share-activity-link',
}

export enum DiscordCustomEvent {
    Ready = 'ready',
    CreateMountPopup = 'create-mount-popup',
}

export enum DiscordMountPopupType {
    UserAlreadyHasMembershipError = 'user-already-has-membership-error'
}

export enum SDKRequest {
    PurchaseMembership,
    PurchaseGift,
    PurchaseCoins,
    InviteFriends,
    ShareMoment,
    OpenExternalLink,
    ShareActivityLink,
}

export interface DiscordUserPermissions {
    canInviteFriends: boolean
}

export interface DiscordServerProfile {
    username: string
    profilePictureUrl: string
    clientVersion: number
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface DiscordServerProfileAPIResponse {
    nick: string | null
    avatar: string | null
    user: DiscordUserAPIResponse
}

export interface DiscordUserAPIResponse {
    id: DiscordSnowflake
    username: string
    discriminator: string
    global_name?: string
    avatar: string | null
    locale?: string
    verified?: boolean
    email?: string | null
    flags?: number
    premium_type?: number
    public_flags?: number
}

export interface DiscordServerAPIResponse {
    id: DiscordSnowflake
    name: string
    owner?: boolean
    approximate_member_count?: number
    approximate_presence_count?: number
    description?: string | null
    preferred_locale?: string
    vanity_url_code?: string | null
}

export interface ShareActivityLinkType {
    message: string
    referrerId: string
    referralTypeId: string
    analyticsPopupTriggered: ShareActivityLinkAnalytics
    analyticsPopupSuccess: ShareActivityLinkAnalytics
}
